import { ChangeDetectionStrategy, Component, model, OnInit, inject } from '@angular/core';
import { ListLinks } from '../../../../@core/constants/list-links';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { AddressBankAccountLink } from '../../../../generated/generated-types';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { AddressBankAccountLinkService } from '../../services/address-bank-account-link.service';
import { bankAccountLinkFallbackFields } from './bank-account-link-fallback-fields';

@Component({
  selector: 'app-bank-account-link-edit-widget',
  templateUrl: '../../../../common/base-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HotkeysService],
  imports: [
    WidgetBaseDetailComponent
  ]
})
export class BankAccountLinkEditWidgetComponent extends BaseDetailComponent<AddressBankAccountLink> implements OnInit {

  addressIdSig = model<string>();

  private bankAccountLinkService = inject(AddressBankAccountLinkService);
  protected override crudService = this.bankAccountLinkService;


  ngOnInit() {
    this.listLink = ListLinks.BANKACCOUNT_LINK;
    this.fallbackFields = bankAccountLinkFallbackFields();
    super.ngOnInit();
  }

  override save(detailModel?: AddressBankAccountLink, skipDiffCheck?: boolean): Promise<AddressBankAccountLink> {
    detailModel = detailModel ?? this.detailModel;
    detailModel.addressId = this.addressIdSig();
    return super.save(detailModel, skipDiffCheck);
  }

}
